import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React from 'react';
import Article from 'app/blocks/article/article';
import { Layout, Title, WhiteBlock } from 'app/blocks/blocks';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import { processing, tryCatch } from 'app/blocks/common/decorators';
import * as middlewareLicense from 'app/blocks/middleware/license';
import * as middlewareC from 'app/blocks/middleware/middleware';
import * as middlewareRequestOO from 'app/blocks/middleware/request-oo';
import { navigate } from 'app/route/history';

type State = {
    article?: Product.Article;
    isCanceling: boolean;
    isLoading: boolean;
    isOrdering: boolean;
    journal?: Product.Journal;
    request?: any;
};

@autobind
class OrdersRequestOOView extends React.PureComponent<{ articleId: string }, State> {
    static propsTypes = {
        articleId: PropTypes.string.isRequired,
    };

    state: State = {
        isLoading: true,
        isOrdering: false,
        isCanceling: false,
    };

    @tryCatch.showPopUpAndGoToDashboard
    @processing('isLoading')
    async componentDidMount() {
        const { articleId } = this.props;

        const [ArticleAndJournal, request] = await Promise.all([
            middlewareC.product.getArticleAndJournal(articleId),
            middlewareRequestOO.getRequest(articleId),
        ]);

        this.setState({
            ...ArticleAndJournal,
            request,
        });
    }

    cancel() {
        navigate('dashboard');
    }

    @tryCatch.popUpOnly
    @processing('isOrdering')
    async orderOnlineOpen() {
        await middlewareLicense.startFlow(this.props.articleId, 'CREATE_OO_ORDER');
    }

    render() {
        const { article, isCanceling, isLoading, isOrdering, journal, request } = this.state;

        return (
            <div className="container">
                <Title>OnlineOpen Request</Title>

                <Layout isLoading={isLoading}>
                    <div className="row m-btm_md">
                        <div className="col-lg-7">
                            <WhiteBlock className="page">
                                <Article article={article} journal={journal} seleniumid="view-oo-request-" />
                            </WhiteBlock>
                        </div>
                    </div>
                    <div className="row m-btm_md">
                        <div className="col-lg-7">
                            <WhiteBlock className="page">
                                <h5 data-seleniumid="view-oo-request-panel-title">Request Details</h5>
                                <div className="border_top" />
                                <div className="m-top_mini">
                                    <span
                                        className="col-4 text_bold p_none"
                                        data-seleniumid="view-oo-request-requester-name-label"
                                    >
                                        {"Requester's Name: "}
                                    </span>
                                    <span data-seleniumid="view-oo-request-requester-name-value">
                                        {request?.requestSubmitter?.name}
                                    </span>
                                </div>
                                <div className="m-top_mini">
                                    <span
                                        className="col-4 text_bold p_none"
                                        data-seleniumid="view-oo-request-requester-email-label"
                                    >
                                        {"Requester's Email Address: "}
                                    </span>
                                    <span data-seleniumid="view-oo-request-requester-email-value">
                                        {request?.requestSubmitter?.email}
                                    </span>
                                </div>
                                <div className="m-top_mini">
                                    <span className="text_bold" data-seleniumid="view-oo-request-message-label">
                                        Message to Corresponding Author
                                    </span>
                                </div>
                                <div className="m-top_mini">
                                    <span className="text_sm" data-seleniumid="view-oo-request-message-value">
                                        {request?.requestNotes}
                                    </span>
                                </div>
                            </WhiteBlock>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="m-top_md">
                                <div className="pull-left">
                                    <Button data-seleniumid="view-oo-request-cancel-button" onClick={this.cancel}>
                                        {isCanceling ? 'Canceling...' : 'Cancel'}
                                    </Button>
                                </div>

                                <div className="pull-right">
                                    <PrimaryButton
                                        data-seleniumid="view-oo-request-order-oo-button"
                                        disabled={isOrdering}
                                        onClick={this.orderOnlineOpen}
                                    >
                                        ORDER OnlineOpen
                                    </PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            </div>
        );
    }
}

export default OrdersRequestOOView;
